<template>
    <Content class="invoice-col-information">
        <div class="col-md-6 ">
            <section class="information-itens">
                <h3>Endereço de entrega</h3>
                <p><strong>CEP: </strong>{{ purchase.address.postal_code }}</p>
                <p>
                    <strong>Cidade: </strong>{{ purchase.address.city }} -
                    {{ purchase.address.uf }}
                </p>
                <p>
                    <strong>Endereço: </strong>{{ purchase.address.address }},
                    {{ purchase.address.number }}
                </p>
                <p><strong>Bairro: </strong>{{ purchase.address.district }}</p>
                <p v-if="purchase.address.phone">
                    <strong>Telefone: </strong>{{ purchase.address.phone }}
                </p>
                <p v-if="purchase.address.reference_location">
                    <strong>Local de referência: </strong
                    >{{ purchase.address.reference_location }}
                </p>
                <p v-if="purchase.address.receiver">
                    <strong>Destinatário: </strong>{{ purchase.address.receiver }}
                </p>
            </section>
            <!-- NOTA FISCAL -->
            <section v-if="purchase.purchase.invoice_url" class="information-itens">
                <h3>Nota fiscal</h3>
                <p v-if="purchase.purchase.invoice_number">
                    <strong>Nota Fiscal N°:</strong>
                    {{ purchase.purchase.invoice_number }}
                </p>
                <p>
                    <strong>
                        <a :href="purchase.purchase.invoice_url" download>
                            Download
                        </a>
                    </strong>
                </p>
            </section>

            <section v-if="getShowPaymentMethods" class="information-itens">
                <h3>Forma de pagamento</h3>
                <!-- PAGSEGURO -->
                <p
                    v-if="
                        purchase.pagseguro &&
                        purchase.pagseguro.length > 0 &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <strong>{{ purchase.purchase.tipo_pagamento }} </strong>
                    <br />
                    <strong v-if="purchase.purchase.payment_type != 'billet'">
                        {{ purchase.purchase.installments }}x de
                        {{ currency.money(purchase.purchase.valor_parcela) }}
                    </strong>
                    <strong v-else>
                        <a :href="purchase.pagseguro.paymentLink" target="_blank">
                            Link do boleto
                        </a>
                    </strong>
                </p>
                <!-- MERCADO PAGO -->
                <p
                    v-if="
                        purchase.mercado_pago &&
                            purchase.mercado_pago.payment &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <strong>
                        {{ purchase.mercado_pago.payment.payment_type_id }}
                    </strong>
                    <br />
                    <strong v-if="purchase.purchase.payment_type != 'billet'">
                        {{ purchase.purchase.installments }}x de
                        {{
                            currency.money(
                                purchase.mercado_pago.payment.transaction_details
                                    .installment_amount
                            )
                        }}
                    </strong>
                    <strong v-else>
                        <a
                            :href="
                                purchase.mercado_pago.payment.transaction_details
                                    .external_resource_url
                            "
                            target="_blank"
                        >
                            Link do boleto
                        </a>
                    </strong>
                </p>
                <p
                    v-else-if="
                        purchase.mercado_pago &&
                            purchase.purchase.payment_status == 'STARTED' &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <strong>Você não efetuou o pagamento</strong><br />
                    <strong>
                        <a
                            :href="purchase.mercado_pago.preference.init_point"
                            target="_blank"
                        >
                            Efetuar pagamento
                        </a>
                    </strong>
                </p>
                <p
                    v-else-if="
                        purchase.mercado_pago &&
                        purchase.mercado_pago.length > 0 &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <strong>{{ purchase.purchase.tipo_pagamento }} ee</strong>
                    <br />
                    <strong v-if="purchase.purchase.payment_type == 'credit'">
                        {{ purchase.purchase.installments }}x de
                        {{ currency.money(purchase.purchase.valor_parcela) }}
                    </strong>
                    <strong v-else-if="purchase.purchase.payment_type == 'billet'">
                        <a :href="purchase.purchase.payment_link" target="_blank">
                            Link do boleto
                        </a>
                    </strong>
                </p>
                <!-- IPAG -->
                <p
                    v-if="
                        purchase.ipag && purchase.purchase.generic_payment == false
                    "
                >
                    <strong v-if="purchase.purchase.payment_type != 'billet'">
                        Cartão {{ purchase.ipag.creditCard.brand }}
                        {{ purchase.ipag.creditCard.number }}<br />
                        {{ purchase.purchase.installments }}x de
                        {{ currency.money(purchase.purchase.valor_parcela) }}
                    </strong>
                    <template v-else>
                        {{ purchase.purchase.tipo_pagamento }}
                        {{ purchase.ipag.acquirer }}<br />
                        <a :href="purchase.ipag.urlAuthentication" target="_blank">
                            Link do boleto
                        </a>
                        <br />
                        <!-- <strong>Vencimento: </strong> {{date('d/m/Y', strtotime(purchase.purchase.billet_due_date))}} <br /> -->
                        <strong>Vencimento: </strong>
                        {{
                            moment(purchase.purchase.billet_due_date).format(
                                "d/m/Y"
                            )
                        }}
                        <br />
                        <template v-if="purchase.purchase.typeful_line">
                            <strong>Linha digitavel: </strong>
                            {{ purchase.purchase.typeful_line }}
                        </template>
                    </template>
                </p>
                <!-- GETNET -->
                <p
                    v-if="
                        purchase.getnet &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <strong v-if="purchase.purchase.payment_type != 'billet'">
                        Cartão {{ purchase.getnet.brand }}<br />
                        {{ purchase.purchase.installments }}x de
                        {{ currency.money(purchase.purchase.valor_parcela) }}
                    </strong>
                    <template v-else>
                        {{ purchase.purchase.tipo_pagamento }}
                        {{ purchase.getnet.boleto.bank }}<br />
                        <a :href="purchase.purchase.payment_link" target="_blank">
                            Link do boleto
                        </a>
                        <br />
                        <!-- <strong>Vencimento: </strong> {{date('d/m/Y', strtotime($data['purchase']->billet_due_date))}} <br /> -->
                        <strong>Vencimento: </strong>
                        {{
                            moment(purchase.purchase.billet_due_date).format(
                                "d/m/Y"
                            )
                        }}
                        <br />
                        <template v-if="purchase.purchase.typeful_line">
                            <strong>Linha digitavel: </strong>
                            {{ purchase.purchase.typeful_line }}
                        </template>
                    </template>
                </p>

                <!-- Yapay -->
                <p
                    v-if="
                        purchase.yapay && purchase.purchase.generic_payment == false
                    "
                >
                    <strong v-if="purchase.purchase.payment_type != 'billet'">
                        Cartão
                        {{
                            purchase.yapay.data_response.transaction.payment
                                .payment_method_name
                        }}<br />
                        {{ purchase.purchase.installments }}x de
                        {{ currency.money(purchase.purchase.valor_parcela) }}
                    </strong>
                    <template v-else>
                        {{ purchase.purchase.tipo_pagamento }}<br />
                        <a :href="purchase.purchase.payment_link" target="_blank">
                            Link do boleto
                        </a>
                        <br />
                        <!-- <strong>Vencimento: </strong> {{date('d/m/Y', strtotime($data['purchase']->billet_due_date))}} <br /> -->
                        <strong>Vencimento: </strong>
                        {{
                            moment(purchase.purchase.billet_due_date).format(
                                "d/m/Y"
                            )
                        }}
                        <br />
                        <template v-if="purchase.purchase.typeful_line">
                            <strong>Linha digitavel: </strong>
                            {{ purchase.purchase.typeful_line }}
                        </template>
                    </template>
                </p>
                <!-- PAGARME -->
                <p
                    v-if="
                        purchase.pagarme &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <strong v-if="purchase.purchase.payment_type != 'billet'">
                        Cartão {{ purchase.pagarme.card_brand }}<br />
                        {{ purchase.purchase.installments }}x de
                        {{ currency.money(purchase.purchase.valor_parcela) }}
                    </strong>
                    <template v-else>
                        {{ purchase.purchase.tipo_pagamento }}<br />
                        <a :href="purchase.purchase.payment_link" target="_blank">
                            Link do boleto
                        </a>
                        <br />
                        <!-- <strong>Vencimento: </strong> {{date('d/m/Y', strtotime($data['purchase']->billet_due_date))}} <br /> -->
                        <strong>Vencimento: </strong>
                        {{
                            moment(purchase.purchase.billet_due_date).format(
                                "d/m/Y"
                            )
                        }}
                        <br />
                        <template v-if="purchase.purchase.typeful_line">
                            <strong>Linha digitavel: </strong>
                            {{ purchase.purchase.typeful_line }}
                        </template>
                    </template>
                </p>
                <!-- GENÉRICO -->
                <p
                    v-if="
                        purchase.purchase.generic_payment &&
                            purchase.purchase.generic_payment == true
                    "
                >
                    <strong>
                        {{ purchase.purchase.payment_company_name }}
                    </strong>
                </p>
                <!-- REDE -->
                <!-- @php
                    $data['rede'] = (array) json_decode($data['rede']);
                @endphp -->
                <p
                    v-if="
                        purchase.rede && purchase.purchase.generic_payment == false
                    "
                >
                    <strong
                        v-if="
                            purchase.purchase.payment_type != 'billet' &&
                                purchase.purchase.generic_payment == false
                        "
                    >
                        Cartão {{ purchase.rede.brandName }}<br/>
                        {{ purchase.purchase.installments }}x de
                        {{ currency.money(purchase.purchase.valor_parcela) }}
                    </strong>
                </p>
                <!-- Dinheiro -->
                <p
                    v-if="
                        purchase.purchase.payment_type == 'money' &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <strong>{{ purchase.purchase.tipo_pagamento }}</strong>
                </p>
                <template
                    v-if="
                        purchase.purchase.payment_type == 'pix' &&
                            purchase.purchase.generic_payment == false
                    "
                >
                    <p>
                        <strong>Pix</strong>
                    </p>
                    <p v-if="purchase.purchase.payment_link">
                        <a :href="purchase.purchase.payment_link" target="_blank">
                            Link do pagamento
                        </a>
                    </p>
                    <c-button
                        :backgroundColor="
                            $root.$children[0].theme.products.button
                                .background_color
                        "
                        :backgroundColorHover="
                            $root.$children[0].theme.products.button
                                .background_color_hover
                        "
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="
                            $root.$children[0].theme.products.button.color_hover
                        "
                        :borderColor="
                            $root.$children[0].theme.products.button
                                .border_color
                        "
                        :borderColorHover="
                            $root.$children[0].theme.products.button
                                .border_color_hover
                        "
                        :borderRadius="
                            $root.$children[0].theme.products.button
                                .border_radius
                        "
                        margin="5px 0 0 0"
                        textTransform="uppercase"
                        height="unset"
                        minWidth="124px"
                        padding="0.5rem 2rem"
                        display="inline-block"
                        textAlign="center"
                        lineHeight="1.5"
                        letterSpacing="0.8px"
                        transition="all .3s"
                        fontSize="1.4rem"
                        type="button"
                        v-clipboard:copy="payloadPix"
                        v-clipboard:success="onCopyPix"
                        v-clipboard:error="onErrorPix"
                    >
                        Copiar chave
                    </c-button>
                </template>

                <!-- BELLUNO CRÉDITO -->
                <!-- @php
                    $payload = json_decode($data['purchase']->payload);
                    // dd($payload)
                @endphp -->
                <template v-if="purchase.gateway">
                    <p
                    v-if="
                        purchase.gateway.payment_gateway_id == 30 ||
                            purchase.gateway.payment_gateway_id == 31
                    "
                >
                    <template v-if="purchase.purchase.payment_type != 'billet'">
                        <!-- @php
                            $installment_value = round(($payload->belluno->value / $payload->belluno->installments_number),2);
                        @endphp -->
                        <strong>
                            Cartão {{ payload.belluno.brand }}<br />
                            Nº {{ payload.belluno.card }}<br />
                            {{ payload.belluno.installments_number }}x de
                            {{ currency.money(installment_value) }}
                        </strong>
                    </template>
                    <template v-else>
                        {{ purchase.purchase.tipo_pagamento }}<br />
                        <a :href="purchase.purchase.payment_link" target="_blank">
                            Link do boleto
                        </a>
                        <br />
                        <!-- <strong>Vencimento: </strong> {{date('d/m/Y', strtotime($data['purchase']->billet_due_date))}} <br /> -->
                        <strong>Vencimento: </strong>
                        {{
                            moment(purchase.purchase.billet_due_date).format(
                                "d/m/Y"
                            )
                        }}
                        <br />
                        <template v-if="purchase.purchase.typeful_line">
                            <strong>Linha digitavel: </strong>
                            {{ purchase.purchase.typeful_line }}
                        </template>
                    </template>
                </p>
                </template>

            </section>
            <section v-if="activeShoppingPortal" class="information-itens">
                <h3>Fornecedor</h3>
                    <p style="font-size: 12px;">{{purchase.purchase.supplier_name}}</p>
            </section>
        </div>

        <div class="col-md-6 table-responsive">
            <table>
                <tr>
                    <th style="width:50%">Subtotal</th>
                    <td>
                        {{ currency.money(purchase.purchase.sub_total) }}
                    </td>
                </tr>
                <tr>
                    <th> Frete
                        <template v-if="showDeliveryMethods">
                            <div v-if="purchase.frenet">
                                <p>
                                    <strong>Transportadora:</strong>
                                    {{ purchase.frenet.Carrier }}
                                </p>
                                <p>
                                    <strong>Tipo de entrega:</strong>
                                    {{ purchase.frenet.ServiceDescription }}
                                </p>
                                <p v-if="purchase.purchase.tracking_code">
                                    <strong>Código de rastreio:</strong>
                                    {{ purchase.purchase.tracking_code }}
                                </p>
                            </div>
                            <div v-if="purchase.shipping">
                                <p>
                                    <strong>Transportadora:</strong>
                                    <!-- @php $transportadora =
                                        ($data['shipping']->transportadora == 'FFLIP FRETES') ?
                                        $data['purchase']->fflip_shipping->type :
                                        $data['shipping']->transportadora; @endphp -->
                                    {{
                                        purchase.shipping.transportadora == "FFLIP FRETES"
                                            ? purchase.purchase.fflip_shipping.type
                                            : purchase.shipping.transportadora
                                    }}
                                </p>
                                <p v-if="purchase.shipping.tipo_entrega != 'FFLIP FRETES'">
                                    <strong>Tipo de entrega:</strong>
                                    {{ purchase.shipping.tipo_entrega }}
                                </p>
                                <p v-if="purchase.purchase.tracking_code">
                                    <strong>Código de rastreio:</strong>
                                    {{ purchase.purchase.tracking_code }}<br />
                                    <a
                                        href="https://www2.correios.com.br/sistemas/rastreamento/"
                                        target="_blank"
                                    >
                                        Rastrear
                                    </a>
                                </p>
                            </div>
                        </template>
                    </th>
                    <td>
                        {{ currency.money(purchase.purchase.shipping_price) }}
                    </td>
                </tr>
                <tr>
                    <th style="width:50%">Desconto:</th>
                    <td>
                        {{ currency.money(purchase.purchase.coupon_discount) }}
                    </td>
                </tr>

                <tr style="font-size: 22px">
                    <th>Total:</th>
                    <td>
                        <strong>
                            {{ currency.money(purchase.purchase.total_amount) }}
                            <template v-if="showIpi && purchase.show_ipi">
                                + IPI
                            </template>
                        </strong>
                    </td>
                </tr>
            </table>
        </div>
    </Content>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import Currency from "../../../../helpers/parseCurrency";
import { Content } from "./style";
import moment from "moment";
import { CButton } from "../../../../../js/components/Styles/Button/styled";

export default {
    name: "PurchaseInformation",
    props: {
        purchase: {
            required: true
        }
    },
    components: {
        Content,
        "c-button": CButton,
    },
    data() {
        return {
            currency: Currency,
            moment,
            payload: null,
            installment_value: null
        };
    },
    mounted() {
        if (
            this.purchase.rede &&
            this.purchase.purchase.generic_payment == false
        ) {
            this.purchase.rede = JSON.parse(this.purchase.rede);
        }
        if (
            this.purchase?.gateway?.payment_gateway_id == 30 ||
            this.purchase?.gateway?.payment_gateway_id == 31
        ) {
            this.payload = JSON.parse(this.purchase.purchase.payload);
            if (purchase.purchase.payment_type != "billet") {
                this.installment_value = (
                    this.payload.belluno.value /
                    this.payload.belluno.installments_number
                ).toFixed(2);
            }
        }
    },
    methods: {
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        onCopyPix: function(e) {
            this.alertToast(
                "Chave copiada para a área de transferência!",
                "check",
                "success"
            );
        },
        onErrorPix: function(e) {
            this.alertToast(
                "Não foi possível copiar a chave!",
                "exclamation-triangle",
                "danger"
            );
        },
        alertToast(
            msg = null,
            icon = "exclamation",
            theme = "warning",
            timer = 7
        ) {
            this.setThemeToast(theme);
            this.setMessageToast(msg);
            this.setIconToast(icon);
            this.setTimerToast(timer);
            this.setShowToast(true);
            setTimeout(() => {
                this.setShowToast(false);
            }, timer * 1000);
        }
    },
    computed: {
        ...mapGetters("company", [
            "showDeliveryMethods",
            "getShowPaymentMethods",
            "showDiscountCoupon",
            "showIpi"
        ]),
        ...mapState("company", ["company"]),
        activeShoppingPortal() {
            return this?.company?.settings?.activate_shopping_portal ?? false;
        },
        payloadPix(){
            try {
                const payload = JSON.parse(this.purchase.purchase?.payload);
                return payload.payload_pix;
            }catch (error) {
                return '';
            }
        }
    }
};
</script>
